import { createSelector } from 'reselect';
import { formValueSelector, getKundenr } from './form';
import { getItemEntries } from './commerce/bucket/selectors';
import { getTime } from './commerce/delivery/dates';
import { storeDateFormat } from './commerce/delivery/dates/shared';
import { hasDeliveryInfo } from './commerce/details';
import { getProductVersion } from './commerce/items';
import { getUserId, getSessionId } from './user';
import {
  getPaymentType,
  paymentTypes,
} from './commerce/payment';
import { getTotalCost } from './commerce';
import { getOldCustomer } from './bestillink';
import { getExternalZip } from './commerce/selectors';
import {
  isInSpecialMode,
  getSpecialDeliveryDate,
  getSpecialNoDeliveryDate,
  deliveryTypes,
  // isDelivery,
} from './commerce/delivery';

const invoiceDetailsSelector = formValueSelector('invoice-details');
const deliveryDetailsSelector = formValueSelector('delivery-details');
const eanDetailsSelector = formValueSelector('ean-form');
const getInvoiceAddress = state => invoiceDetailsSelector(
  state,
  'address',
  'attName',
  'city',
  'zipCode',
  'name',
  'phonenumber',
  'extraPhonenumbers',
  'extraEmails',
);
const getDeliveryAddress = state => deliveryDetailsSelector(
  state,
  'address',
  'attName',
  'city',
  'zipCode',
  'name',
  'phonenumber',
  'extraPhonenumbers',
);


const getComment = state => invoiceDetailsSelector(state, 'comment');
const getEmail = state => invoiceDetailsSelector(state, 'email');


const getEanDetails = state => eanDetailsSelector(state, 'ean', 'cvr', 'eanReference');
export const getDeliveryInfo = (state) => {
  const {
    commerce: {
      delivery,
    },
  } = state;
  const { dates } = delivery;
  const newDates = Object.keys(dates).reduce(
    (acc, deliveryType) => {
      const d1 = dates[deliveryType];
      return {
        ...acc,
        [deliveryType]: Object.keys(d1).reduce(
          (acc2, dateType) => {
            const d2 = d1[dateType];
            const realTime = getTime(deliveryType)(dateType)(state);
            return {
              ...acc2,
              [dateType]: {
                ...d2,
                time: realTime,
              },
            };
          },
          {},
        ),
      };
    },
    {},
  );
  if (isInSpecialMode(state)) {
    const specialDeliveryDate = getSpecialDeliveryDate(state);
    const specialNoDeliveryDate = getSpecialNoDeliveryDate(state);
    newDates[deliveryTypes.delivery].date = specialDeliveryDate && specialDeliveryDate.format(storeDateFormat);
    newDates[deliveryTypes.no].date = specialNoDeliveryDate && specialNoDeliveryDate.format(storeDateFormat);
  }
  return {
    ...delivery,
    dates: newDates,
  };
};

createSelector(
  state => state.commerce.delivery,
  delivery => delivery,
);
export const getCompleteOrder = createSelector(
  isInSpecialMode,
  getItemEntries,
  getComment,
  getEmail,
  getInvoiceAddress,
  getDeliveryAddress,
  getEanDetails,
  hasDeliveryInfo,
  getPaymentType,
  getDeliveryInfo,
  getProductVersion,
  getTotalCost,
  getKundenr,
  getOldCustomer,
  getUserId,
  getSessionId,
  getExternalZip,
  (
    isSpecialMode,
    itemEntries,
    comment,
    email,
    invoiceAddress,
    deliveryAddress,
    eanDetails,
    hasDeliveryAddress,
    paymentMethod,
    delivery,
    productVersion,
    total,
    actualKundenr,
    oldCustomer,
    userId,
    sessionId,
    externalDelivery,
  ) => {
    if (isSpecialMode) {
      return {
        itemEntries,
        comment,
        email,
        invoiceAddress,
        deliveryAddress: null,
        paymentMethod: paymentTypes.card,
        eanDetails: null,
        delivery,
        productVersion,
        total: Math.round(total),
        kundenr: actualKundenr,
        oldCustomer,
        userId,
        sessionId,
        isTest: Boolean(window.__IS_TEST__), // eslint-disable-line
        externalDelivery: externalDelivery && true,
        isSpecial: true,
      };
    }
    return {
      itemEntries,
      comment,
      email,
      invoiceAddress,
      deliveryAddress: hasDeliveryAddress ? deliveryAddress : null,
      paymentMethod,
      eanDetails: paymentMethod === paymentTypes.eanInvoice ? eanDetails : null,
      delivery,
      productVersion,
      total: Math.round(total),
      kundenr: actualKundenr,
      oldCustomer,
      userId,
      sessionId,
      isTest: Boolean(window.__IS_TEST__), // eslint-disable-line
      externalDelivery: externalDelivery && true,
      isSpecial: false,
    };
  },
);
